import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import styled from 'styled-components';

import { ConsentStorage } from '@hivebrite/design-system/Embed';
import { FakeLink } from '@hivebrite/design-system/Link';

import ThemeProvider from 'hb-react/style/ThemeProvider';

const WithdrawConsentBtn = ({ colorFooterLinks }) => {
  const onClick = () => {
    // Clean up ds-embed consents settings.
    ConsentStorage.resetStorage();

    Cookies.remove('cookie_consent_list_fo');
    window.location.reload();
  };

  return (
    <ThemeProvider theme="po" options={{ customNetworkColors: {} }}>
      <StyledFakeLink
        onClick={onClick}
        colorFooterLinks={colorFooterLinks}
        data-testid="cookie-bar-fake-link"
      >
        <StyledDotdotdot clamp={2} useNativeClamp>
          {s__('CookieSettings|Withdraw cookie consent')}
        </StyledDotdotdot>
      </StyledFakeLink>
    </ThemeProvider>
  );
};

WithdrawConsentBtn.propTypes = {
  colorFooterLinks: PropTypes.string,
};

export default WithdrawConsentBtn;

const StyledFakeLink = styled(FakeLink).withConfig({
  shouldForwardProp: (prop) => !['colorFooterLinks'].includes(prop),
})`
  color: ${({ colorFooterLinks }) => colorFooterLinks} !important;
`;

const StyledDotdotdot = styled(Dotdotdot)`
  max-width: 100%;
  font-weight: normal;
  font-size: 11px !important;
  line-height: 13px !important;
`;
